// extracted by mini-css-extract-plugin
export default {"gridWrapper":"common_gridWrapper__fddqV"};